<div [ngClass]="Theme">
    <ng-content select="[head-content]"></ng-content>
</div>